import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { InputCheckBox } from "@itandi/itandi-bb-ui/InputCheckBox";
import React from "react";
import { useFormContext } from "react-hook-form";
import type {
	AddressType,
	NotificationEdit,
	NotificationMail
} from "~/models/Notification";
import { isTodoNotification } from "~/models/Notification";
import Styles from "../NotificationModal.module.scss";

export function NotificationMailsCheckBox() {
	const { watch, formState, setValue } = useFormContext<NotificationEdit>();
	const { errors } = formState;
	const notificationMails = watch("notificationMails");
	const onChangeCheckBox = React.useCallback(
		(
			e: React.ChangeEvent<HTMLInputElement>,
			addressType: AddressType
		): void => {
			const { checked } = e.target;
			if (checked) {
				setValue("notificationMails", [...notificationMails, { addressType }]);
			} else {
				setValue("notificationMails", [
					...notificationMails.filter(
						(notificationMail) => notificationMail.addressType !== addressType
					)
				]);
			}
		},
		[notificationMails, setValue]
	);
	const findNotificationMail = (
		addressType: AddressType
	): DeepReadonly<NotificationMail> | null =>
		notificationMails.find(
			(notificationMail) => notificationMail.addressType === addressType
		) ?? null;

	return (
		<>
			<Flex gap={8}>
				<InputCheckBox
					checked={!!findNotificationMail("deal_staff")}
					isInvalid={!!errors.notificationMails}
					label="案件担当者"
					onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
						onChangeCheckBox(e, "deal_staff");
					}}
				/>
				<InputCheckBox
					checked={!!findNotificationMail("store")}
					isInvalid={!!errors.notificationMails}
					label="店舗通知先"
					onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
						onChangeCheckBox(e, "store");
					}}
				/>
				{isTodoNotification(watch("triggerType"), watch("triggerDateType")) && (
					<InputCheckBox checked disabled label="TODO担当者" />
				)}
			</Flex>
			{errors.notificationMails ? (
				<div className={Styles.InvalidFeedback}>
					{errors.notificationMails.message}
				</div>
			) : null}
		</>
	);
}
